import { useRef } from "preact/hooks";
import "./SearchBarComponent.scss"

const SearchBarComponent = ({value = null}) => {
    const searchInputRef = useRef(null);

    const handleSearch = (query: string) => {
        window.location.href = '/search/' + query;
    }

    const handleInput = (e) => {
        if (e.key === "Enter") {
            handleSearch(e.target.value);
        }
    }

    return (<div className={"search-bar-container"}>
        <div className={"search-bar-wrapper"}>
            <input type="text"
                placeholder={"Example: \"pizza\" or \"dominos\"..."}
                className={"search-input"}
                ref={searchInputRef}
                onKeyDown={handleInput}
                value={value}/>
            <div className={"search-bar-icon-container"} onClick={() => handleSearch(searchInputRef.current?.value)}>
                <i className={"fas fa-search"}/>
            </div>
        </div>
    </div>)
};

export default SearchBarComponent;